import { makeStyles, shorthands, tokens } from "@fluentui/react-components";

export const useStyles = makeStyles({
  dialogSurface: {
    maxWidth: "650px",
    maxHeight: "80vh",
  },
  dialogContent: {
    height: "calc(80vh - 120px)",
    paddingBottom: "16px",
    display: "flex",
    flexDirection: "column",
  },
  tabContent: {
    flex: 1,
    minHeight: 0,
    overflowY: "auto" as const,
  },
  fieldContainer: {
    marginBottom: "12px",
  },
  fieldLabel: {
    fontWeight: 600,
    marginBottom: "2px",
    fontSize: "13px",
  },
  fieldValue: {
    color: tokens.colorNeutralForeground1,
    fontSize: "13px",
  },
  promptContent: {
    backgroundColor: tokens.colorNeutralBackground3,
    padding: "8px",
    borderRadius: "4px",
    maxHeight: "300px",
    overflowY: "auto",
    lineHeight: 1.4,
    fontSize: "13px",
    "& p": { marginBlock: tokens.spacingVerticalXS },
    "& ul, & ol": { marginInlineStart: tokens.spacingHorizontalM },
    "& code, & pre": {
      backgroundColor: tokens.colorNeutralBackground4,
      ...shorthands.borderRadius(tokens.borderRadiusSmall),
      ...shorthands.padding("2px", tokens.spacingHorizontalXS),
    },
    "& a": {
      color: "var(--colorBrandForegroundLink)",
      textDecoration: "none",
      ":hover": { textDecoration: "underline" },
    },
    wordBreak: "break-word",
  },
  toggleRow: {
    display: "flex",
    gap: "16px",
    flexWrap: "wrap",
    fontSize: "13px",
  },
  toggleItem: {
    display: "flex",
    alignItems: "center",
    gap: "4px",
  },
});
